var _path, _path2, _circle, _circle2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNpsHappy(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.49998 14.6673C12.1819 14.6673 15.1666 11.6825 15.1666 8.00065C15.1666 4.31875 12.1819 1.33398 8.49998 1.33398C4.81808 1.33398 1.83331 4.31875 1.83331 8.00065C1.83331 11.6825 4.81808 14.6673 8.49998 14.6673Z",
    stroke: "#008908",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.2006 9.88622C12.4532 10.0149 12.556 10.326 12.4003 10.5629C12.0243 11.1353 11.5257 11.6197 10.9383 11.9796C10.2045 12.4293 9.36062 12.6673 8.49998 12.6673C7.63934 12.6673 6.79547 12.4293 6.06165 11.9796C5.47422 11.6197 4.97564 11.1353 4.59966 10.5629C4.444 10.326 4.54673 10.0149 4.79933 9.88623C5.05194 9.75752 5.35826 9.86064 5.52119 10.0926C5.80619 10.4985 6.1722 10.8433 6.59809 11.1043C7.17046 11.455 7.82868 11.6407 8.49998 11.6407C9.17128 11.6407 9.8295 11.455 10.4019 11.1043C10.8278 10.8433 11.1938 10.4985 11.4788 10.0926C11.6417 9.86064 11.948 9.75752 12.2006 9.88622Z",
    fill: "#008908"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 4.83331,
    cy: 7.66602,
    r: 1,
    fill: "#008908"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 12.1667,
    cy: 7.66602,
    r: 1,
    fill: "#008908"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNpsHappy);
export default __webpack_public_path__ + "static/media/NpsHappy.e26d39bf.svg";
export { ForwardRef as ReactComponent };